import { Component } from '@angular/core';

@Component({
    selector: 'view-child-ina',
    templateUrl: './view-child-ina.component.html',
    styleUrl: './view-child-ina.component.scss'
})
export class ViewChildInaComponent {}
